import React from 'react'
import { useFetchFeedbackModificationStatsQuery } from '../../../../../../../store/apis/analytics.api'
import AcceptanceAnalyticsByCategoryTable from '../components/AcceptanceAnalyticsByCategoryTable'

const FeedbackModificationStatsChart = ({ token }) => {
    const { data: analytics, isFetching, error } = useFetchFeedbackModificationStatsQuery({ token })

    return (
        <AcceptanceAnalyticsByCategoryTable
            analytics={analytics}
            isFetching={isFetching}
            error={error}
            description='This table shows the percentage of AI-generated feedback that was modified by reviewers across different questions, rubrics, categories, and confidence levels. Click on a question row to expand and see the breakdown by rubric, then expand a rubric to see the breakdown by category. If no feedback has been reviewed, "N/A" is shown.'
        />
    )
}

export default FeedbackModificationStatsChart